import InventoryAlphaListing from './InventoryAlphaListing';

export default InventoryAlphaListing;
